/**
 * Product template (PDP): gallery prev/next + thumbnails, variant UI sync.
 * Loaded explicitly from the product section so behavior does not depend on the
 * theme’s concatenated scripts.js bundle alone.
 */
(function () {
  if (window.__AJ_PRODUCT_PAGE_JS__) return;
  window.__AJ_PRODUCT_PAGE_JS__ = true;

  var preloadedSrcs = new Set();

  function readProductPageConfig(page) {
    if (!page) return null;
    var el = page.querySelector('.product-page__data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function preloadImageSrc(src) {
    if (!src || preloadedSrcs.has(src)) return;
    preloadedSrcs.add(src);
    var img = new Image();
    img.src = src;
  }

  function preloadPanelImages(panel) {
    if (!panel) return;
    var imgs = panel.querySelectorAll('img.product-page__img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete) continue;
      img.loading = 'eager';
      var src = img.currentSrc || img.src;
      if (src) preloadImageSrc(src);
    }
  }

  function preloadAdjacentPanels(galleryMain, visiblePanel) {
    if (!galleryMain || !visiblePanel) return;
    var panels = Array.prototype.slice.call(
      galleryMain.querySelectorAll('.product-page__media-panel[data-media-id]')
    );
    var idx = panels.indexOf(visiblePanel);
    if (idx < 0 || panels.length < 2) return;
    var len = panels.length;
    preloadPanelImages(panels[(idx + 1) % len]);
    preloadPanelImages(panels[(idx - 1 + len) % len]);
  }

  function warmGalleryPreload(galleryRoot) {
    if (!galleryRoot) return;
    var galleryMain = galleryRoot.querySelector('[data-product-gallery-main]');
    if (!galleryMain) return;
    var panels = Array.prototype.slice.call(
      galleryMain.querySelectorAll('.product-page__media-panel[data-media-id]')
    );
    var visible = panels.find(function (p) {
      return !p.hidden;
    });
    if (!visible) return;
    preloadPanelImages(visible);
    preloadAdjacentPanels(galleryMain, visible);
  }

  function panelForGalleryThumb(galleryRoot, thumb) {
    if (!galleryRoot || !thumb) return null;
    var controls = thumb.getAttribute('aria-controls');
    if (controls) {
      return document.getElementById(controls);
    }
    var id = thumb.getAttribute('data-product-gallery-thumb');
    if (id == null) return null;
    var galleryMain = galleryRoot.querySelector('[data-product-gallery-main]');
    if (!galleryMain) return null;
    return galleryMain.querySelector(
      '.product-page__media-panel[data-media-id="' + String(id) + '"]'
    );
  }

  function showGalleryMedia(galleryRoot, mediaId) {
    if (!galleryRoot || mediaId == null) return;
    var galleryMain = galleryRoot.querySelector('[data-product-gallery-main]');
    if (!galleryMain) return;
    var idStr = String(mediaId);
    var panels = Array.prototype.slice.call(
      galleryMain.querySelectorAll('.product-page__media-panel[data-media-id]')
    );
    var panel = galleryMain.querySelector('.product-page__media-panel[data-media-id="' + idStr + '"]');
    if (!panel || panels.length === 0) return;

    panels.forEach(function (p) {
      p.hidden = p !== panel;
    });

    galleryRoot.querySelectorAll('[data-product-gallery-thumb]').forEach(function (btn) {
      var bid = btn.getAttribute('data-product-gallery-thumb');
      var selected = bid === idStr;
      btn.classList.toggle('is-selected', selected);
      if (selected) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });

    preloadPanelImages(panel);
    preloadAdjacentPanels(galleryMain, panel);
  }

  function stepGalleryMedia(galleryRoot, dir) {
    var galleryMain = galleryRoot.querySelector('[data-product-gallery-main]');
    if (!galleryMain) return;
    var panels = Array.prototype.slice.call(
      galleryMain.querySelectorAll('.product-page__media-panel[data-media-id]')
    );
    var ids = panels.map(function (el) {
      return String(el.getAttribute('data-media-id'));
    });
    if (ids.length < 2) return;
    var visible = panels.find(function (p) {
      return !p.hidden;
    });
    var cur = visible ? String(visible.getAttribute('data-media-id')) : ids[0];
    var i = ids.indexOf(cur);
    if (i < 0) i = 0;
    var nextId = ids[(i + dir + ids.length) % ids.length];
    showGalleryMedia(galleryRoot, nextId);
  }

  function syncGalleryToSelectedVariant() {
    var page = document.querySelector('.product-page');
    var cfg = readProductPageConfig(page);
    if (!cfg || !page) return;
    var galleryRoot = page.querySelector('[data-product-gallery]');
    if (!galleryRoot) return;
    var form = page.querySelector('.product-page__form');
    var variantInput = form && form.querySelector('[data-variant-id]');
    var vid =
      variantInput && variantInput.value
        ? variantInput.value
        : String(cfg.selectedVariantId);
    if (!cfg.variantFeaturedMedia) return;
    var mid = cfg.variantFeaturedMedia[vid];
    if (mid != null) {
      showGalleryMedia(galleryRoot, mid);
    }
  }

  function getOptionGroups(form) {
    return Array.prototype.slice
      .call(form.querySelectorAll('[data-product-option-index]'))
      .sort(function (a, b) {
        return (
          parseInt(a.getAttribute('data-product-option-index'), 10) -
          parseInt(b.getAttribute('data-product-option-index'), 10)
        );
      });
  }

  function getSelectedOptions(form) {
    var groups = getOptionGroups(form);
    return groups.map(function (g) {
      var checked = g.querySelector('.product-page__option-input:checked');
      return checked ? checked.value : '';
    });
  }

  function findVariantBySelections(cfg, selectedOptions) {
    if (!cfg.variants || !cfg.variants.length) return undefined;
    if (!selectedOptions.length) {
      return cfg.variants[0];
    }
    return cfg.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });
  }

  function findVariant(cfg, form) {
    return findVariantBySelections(cfg, getSelectedOptions(form));
  }

  function existsVariantForValue(cfg, selections, optIndex, value) {
    if (!cfg.variants) return false;
    return cfg.variants.some(function (v) {
      for (var j = 0; j < v.options.length; j++) {
        if (j === optIndex) {
          if (v.options[j] !== value) return false;
        } else if (v.options[j] !== selections[j]) {
          return false;
        }
      }
      return true;
    });
  }

  function existsAvailableVariantForValue(cfg, selections, optIndex, value) {
    if (!cfg.variants) return false;
    return cfg.variants.some(function (v) {
      if (!v.available) return false;
      for (var j = 0; j < v.options.length; j++) {
        if (j === optIndex) {
          if (v.options[j] !== value) return false;
        } else if (v.options[j] !== selections[j]) {
          return false;
        }
      }
      return true;
    });
  }

  function stabilizeVariantSelection(form, cfg) {
    var maxIter = 12;
    while (maxIter-- > 0) {
      var selections = getSelectedOptions(form);
      if (findVariantBySelections(cfg, selections)) {
        return;
      }
      var fixed = false;
      for (var oi = 0; oi < selections.length; oi++) {
        if (existsVariantForValue(cfg, selections, oi, selections[oi])) {
          continue;
        }
        var group = form.querySelector('[data-product-option-index="' + oi + '"]');
        if (!group) break;
        var inputs = group.querySelectorAll('.product-page__option-input');
        for (var i = 0; i < inputs.length; i++) {
          var val = inputs[i].value;
          if (existsVariantForValue(cfg, selections, oi, val)) {
            inputs[i].checked = true;
            fixed = true;
            break;
          }
        }
        if (fixed) break;
      }
      if (!fixed) break;
    }
  }

  function refreshOptionAvailability(form, cfg) {
    var selections = getSelectedOptions(form);
    if (!selections.length) return;
    getOptionGroups(form).forEach(function (group) {
      var optIndex = parseInt(group.getAttribute('data-product-option-index'), 10);
      group.querySelectorAll('.product-page__option-input').forEach(function (input) {
        var value = input.value;
        var possible = existsVariantForValue(cfg, selections, optIndex, value);
        var purchasable = existsAvailableVariantForValue(cfg, selections, optIndex, value);
        input.disabled = !possible;
        var label = group.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.toggle('is-sold-out', possible && !purchasable);
          label.classList.toggle('is-disabled', !possible);
        }
      });
    });
  }

  function applyVariantToUi(form, page, cfg, v) {
    if (!v) return;
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = page.querySelector('[data-product-price]');
    var submitBtn = form.querySelector('.product-page__submit');
    var pid = String(v.id);
    if (variantInput) variantInput.value = v.id;
    if (priceEl && cfg.variantPrices && cfg.variantPrices[pid]) {
      priceEl.textContent = cfg.variantPrices[pid];
    }
    if (submitBtn) {
      submitBtn.disabled = !v.available;
    }
    var galleryRoot = page.querySelector('[data-product-gallery]');
    if (
      galleryRoot &&
      cfg.variantFeaturedMedia &&
      cfg.variantFeaturedMedia[pid] != null
    ) {
      showGalleryMedia(galleryRoot, cfg.variantFeaturedMedia[pid]);
    }
  }

  function syncVariantFromForm(form) {
    var page = form.closest('.product-page');
    if (!page) return;
    var cfg = readProductPageConfig(page);
    if (!cfg) return;
    stabilizeVariantSelection(form, cfg);
    refreshOptionAvailability(form, cfg);
    var v = findVariant(cfg, form);
    applyVariantToUi(form, page, cfg, v);
  }

  function onGalleryClick(e) {
    var raw = e.target;
    if (!raw) return;
    var el = raw.nodeType === 1 ? raw : raw.parentElement;
    if (!el || typeof el.closest !== 'function') return;
    var trigger = el.closest(
      '[data-product-gallery-thumb], [data-product-gallery-prev], [data-product-gallery-next]'
    );
    if (!trigger) return;
    var galleryRoot = trigger.closest('[data-product-gallery]');
    if (!galleryRoot) return;

    if (trigger.hasAttribute('data-product-gallery-thumb')) {
      e.preventDefault();
      showGalleryMedia(galleryRoot, trigger.getAttribute('data-product-gallery-thumb'));
      var main = galleryRoot.querySelector('[data-product-gallery-main]');
      if (main && main.focus) {
        try {
          main.focus({ preventScroll: true });
        } catch (err) {
          main.focus();
        }
      }
      return;
    }
    if (trigger.hasAttribute('data-product-gallery-prev')) {
      e.preventDefault();
      stepGalleryMedia(galleryRoot, -1);
      return;
    }
    if (trigger.hasAttribute('data-product-gallery-next')) {
      e.preventDefault();
      stepGalleryMedia(galleryRoot, 1);
    }
  }

  document.addEventListener('click', onGalleryClick, true);

  document.addEventListener('mouseover', function (e) {
    var raw = e.target;
    if (!raw) return;
    var el = raw.nodeType === 1 ? raw : raw.parentElement;
    if (!el || typeof el.closest !== 'function') return;
    var thumb = el.closest('[data-product-gallery-thumb]');
    if (!thumb) return;
    var galleryRoot = thumb.closest('[data-product-gallery]');
    if (!galleryRoot) return;
    var panel = panelForGalleryThumb(galleryRoot, thumb);
    if (panel) preloadPanelImages(panel);
  });

  document.addEventListener('focusin', function (e) {
    var thumb = e.target && e.target.closest && e.target.closest('[data-product-gallery-thumb]');
    if (!thumb) return;
    var galleryRoot = thumb.closest('[data-product-gallery]');
    if (!galleryRoot) return;
    var panel = panelForGalleryThumb(galleryRoot, thumb);
    if (panel) preloadPanelImages(panel);
  });

  function initGalleryPreload() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (galleryRoot) {
      warmGalleryPreload(galleryRoot);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var ae = document.activeElement;
    if (!ae || !ae.closest) return;
    var main = ae.closest('[data-product-gallery-main]');
    if (!main) return;
    var galleryRoot = main.closest('[data-product-gallery]');
    if (!galleryRoot) return;
    var galleryMain = galleryRoot.querySelector('[data-product-gallery-main]');
    var count = galleryMain.querySelectorAll('.product-page__media-panel[data-media-id]').length;
    if (count < 2) return;
    e.preventDefault();
    stepGalleryMedia(galleryRoot, e.key === 'ArrowRight' ? 1 : -1);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('.product-page__option-input')) return;
    var form = sel.closest('.product-page__form');
    if (!form) return;
    syncVariantFromForm(form);
  });

  function initProductVariantUi() {
    document.querySelectorAll('.product-page__form').forEach(function (form) {
      if (!form.querySelector('.product-page__option-input')) return;
      syncVariantFromForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      requestAnimationFrame(function () {
        initProductVariantUi();
        syncGalleryToSelectedVariant();
        initGalleryPreload();
      });
    });
  } else {
    requestAnimationFrame(function () {
      initProductVariantUi();
      syncGalleryToSelectedVariant();
      initGalleryPreload();
    });
  }

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(function () {
      initProductVariantUi();
      syncGalleryToSelectedVariant();
      initGalleryPreload();
    });
  });
})();
